<template>
  <div class="form-create">
    <template v-for="(column, index) in columns">
      <template v-if="!column.column">
        <template v-if="column.type === 'title'">
          <formTitle :column="column" :key="index"></formTitle>
        </template>
        <template v-if="column.type === 'input'">
          <formInput :column="column" :key="index"></formInput>
        </template>
        <template v-if="column.type === 'radio'">
          <formRadio :column="column" :key="index"></formRadio>
        </template>
        <template v-if="column.type === 'checkbox'">
          <formCheckbox :column="column" :key="index"></formCheckbox>
        </template>
        <template v-if="column.type === 'textarea'">
          <formTextarea :column="column" :key="index"></formTextarea>
        </template>
        <template v-if="column.type === 'rate'">
          <formRate :column="column" :key="index"></formRate>
        </template>
        <template v-if="column.type === 'number'">
          <formNumber :column="column" :key="index"></formNumber>
        </template>
      </template>
      <template v-else>
        <formGroup :groupColumn="column" :key="index"></formGroup>
      </template>
    </template>
  </div>
</template>

<script>
import formTitle from './form/title'
import formInput from './form/input'
import formTextarea from './form/textarea'
import formRadio from './form/radio'
import formCheckbox from './form/checkbox'
import formRate from './form/rate'
import formGroup from './form/group'
import formNumber from './form/number.vue'
export default {
  props: ['formOptions'],
  components: {
    formTitle,
    formInput,
    formTextarea,
    formRadio,
    formCheckbox,
    formRate,
    formGroup,
    formNumber
  },
  data() {
    return {
      columns: []
    }
  },
  mounted() {
    this.deelOptions(this.formOptions)
  },
  methods: {
    deelOptions(options) {
      const optionJson = JSON.parse(options)
      const column = optionJson.column || []
      const group = optionJson.group || []
      this.columns = [...column, ...group]
    }
  }
}
</script>

<style scoped lang="scss">
.form-create {
}
</style>
